module.exports = __webpack_public_path__ + "img/astro.febb94f3.png";